const { createRecipeTiles } = require('../shop/tiles/recipe-tile-factory');
const { get } = require('lodash');

class RecipeTileListController {
    constructor($window, settings, analyticsService, recipeService, sortByKeys) {
        this.$window = $window;
        this.analyticsService = analyticsService;
        this.settings = settings;
        this.recipeService = recipeService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        const recipeTilesPromise = this.recipeService.getRecipes(this.currentCategory.aisle.ID, pageSize, pageNumber, sortType).then(tiles => this.createTiles(tiles));

        if (get(this.currentCategory, 'department.UrlFriendlyName') !== 'fresh-magazine') {
            recipeTilesPromise.then(tiles => this.analyticsService.push({
                data: {
                    currentCategory: this.currentCategory,
                    resultsCategoryCount: tiles.totalRecordCount,
                    numberOfPage: pageNumber,
                    pageSortBy: sortType,
                    SortTypes: this.sortOptions.sortTypes,
                    recipes: tiles,
                    homeUrl: this.$window.location.origin,
                },
                type: this.analyticsService.mapperTypes.content.recipeCategory,
            }));
        }
        return recipeTilesPromise;
    }
}

RecipeTileListController.$inject = ['$window', 'Settings', 'AnalyticsService', 'RecipeService', 'SortByKeys'];

const recipeTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: RecipeTileListController,
    template: `
        <wow-tile-list
            list-title="::$ctrl.currentCategory.aisle.Name"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    RecipeTileListController,
    recipeTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-tile-list.component.js